import React from 'react';

import type { AssistanceServiceInputParam } from '@atlassian/conversation-assistant-service/services/assistance-service/main';

import { useSetViewMoreModalParams } from './useSetViewMoreModalParams';

/**
 * Call this from a component that has chatModeKey and assistanceServiceParams
 * (e.g. ChatPromptInput) to supply them to the View more modal content.
 */
export const useViewMoreModalParamsEffect = (
	chatModeKey: string,
	assistanceServiceParams: AssistanceServiceInputParam['assistanceServiceParams'] | undefined,
): void => {
	const setParams = useSetViewMoreModalParams();
	React.useEffect(() => {
		if (assistanceServiceParams) {
			setParams({ chatModeKey, assistanceServiceParams });
			return () => setParams(null);
		}
	}, [chatModeKey, assistanceServiceParams, setParams]);
};
